import { type AxiosRequestConfig } from 'axios'

const login = (email: string, password: string): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/login',
    data: {
      email,
      password,
    },
  }
}

export { login }
